// @ts-nocheck a5a60aa1
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_grid'],
      sections: [addPanel.sections.getSections().developer.gridSection],
    };
  },
};
